import { RefreshCw } from 'lucide-react';

const hhmm = (iso) => (iso ? new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '');

// "Updated HH:MM" = last completed report calculation; "Refreshing…" = newer entries are being processed (reopen to see them).
export function FreshnessTag({ freshness, fetchedAt, testId = 'report-freshness' }) {
  const at = freshness?.updated_at || fetchedAt;
  if (!at) return null;
  return (
    <span className="inline-flex items-center gap-1 text-[10px] text-muted-foreground" data-testid={testId}>
      Updated {hhmm(at)}
      {freshness?.refreshing && (
        <span className="inline-flex items-center gap-0.5 text-amber-700" data-testid={`${testId}-refreshing`} title="Newer entries are being added to this report. Reload in a minute to include them.">
          · <RefreshCw size={10} className="animate-spin" /> Refreshing…
        </span>
      )}
    </span>
  );
}
